module.exports = __webpack_public_path__ + "img/wuxi.5e7328c.png";